import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import React from 'react';

const IconExternalLink = /*#__PURE__*/React.memo(props => {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.97 10.03a.75.75 0 0 1 0-1.06l1.72-1.72H18.5A5.75 5.75 0 0 0 12.75 13a.75.75 0 0 1-1.5 0 7.25 7.25 0 0 1 7.25-7.25h1.19l-1.72-1.72a.75.75 0 0 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-1.06 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 18.75V7.25h7.25a.75.75 0 0 0 0-1.5h-8a.75.75 0 0 0-.75.75v13c0 .414.336.75.75.75h19a.75.75 0 0 0 .75-.75v-8a.75.75 0 0 0-1.5 0v7.25H3.25Z"
  })));
});
IconExternalLink.displayName = 'IconExternalLink';

export { IconExternalLink };
